/**
 * @fileoverview Scrollbar — injects global themed scrollbar styles.
 * Renders nothing; imported for its CSS side-effect only.
 * Mount once in App.tsx alongside CustomCursor.
 */
import './Scrollbar.css';

export function Scrollbar(): null {
  return null;
}
